module.exports = __webpack_public_path__ + "media/images/flags/NP-ef8e3b215908fabef275fc6744615b99.svg";